var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder",
    attrs: {
      "id": "trending-course"
    }
  }, [(_vm.$store.getters.getAllCOs !== undefined && _vm.$store.getters.getAllCOs !== null && _vm.$store.getters.getAllCOs.length > 0) ? _c('div', {
    staticClass: "pb-2 row justify-content-end"
  }, [_c('h6', {
    staticClass: "main-title col-12 text-left"
  }, [_vm._v(_vm._s(_vm.$t('course.trending_courses')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getAllCOs !== undefined && _vm.$store.getters.getAllCOs !== null && _vm.$store.getters.getAllCOs.length > 0) ? _c('div', {
    staticClass: "swiper-holder"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptionLib
    }
  }, _vm._l((_vm.$store.getters.getAllCOs), function(course, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "card-design"
    }, [(course.thumbnail.length != 0) ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/assets/images/defaultCO.jpg"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "tag": "h3",
        "title": course.title,
        "to": {
          name: 'coursePage',
          params: {
            contentId: course.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": course.title
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.OVERALL_RATING')))]) : _vm._e(), _vm._v(" "), (parseInt(course.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating.toFixed(1)),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": true
      }
    }), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
      staticClass: "row box-action"
    }, [_c('div', {
      staticClass: "col"
    }, [(_vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    }) != undefined && _vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    }) != null && _vm.$store.getters.getItemSubscriptionStatus({
      'id': course.contentId,
      'type': course.type
    })) ? _c('div', [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToCourse(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('course.GO_TO_COURSE')))])]) : (_vm.featureStatusInfoList.cart) ? _c('div', [(_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(course.contentId)) ? _c('button', {
      staticClass: "btn btn-green-alt"
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADDED')))]) : _c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.addToCart(course.contentId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e()]), _vm._v(" "), (_vm.featureStatusInfoList.wishlist && _vm.$store.getters.getItemPurchasedStatus(course.contentId) != undefined && _vm.$store.getters.getItemPurchasedStatus(course.contentId) != null && !_vm.$store.getters.getItemPurchasedStatus(course.contentId)) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [(_vm.$store.getters.itemPresentInWishListStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInWishListStatus(course.contentId) != null && _vm.$store.getters.itemPresentInWishListStatus(course.contentId)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && !_vm.$store.getters.itemPresentInCartStatus(course.contentId)),
        expression: "$store.getters.itemPresentInCartStatus(course.contentId) != undefined && $store.getters.itemPresentInCartStatus(course.contentId)!= null && !$store.getters.itemPresentInCartStatus(course.contentId)"
      }],
      staticClass: "heart",
      class: {
        'is-active': true
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.removeFromWishList(course.contentId)
        }
      }
    })]) : (_vm.$store.getters.itemPresentInCartStatus(course.contentId) != undefined && _vm.$store.getters.itemPresentInCartStatus(course.contentId) != null && _vm.$store.getters.itemPresentInCartStatus(course.contentId)) ? _c('div') : _c('div', [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.addToWishList(course.contentId)
        }
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row box-action"
    }, [(_vm.featureStatusInfoList.cart) ? _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.ADD_TO_CART')))])]) : _vm._e(), _vm._v(" "), (_vm.featureStatusInfoList.wishlist) ? _c('div', {
      staticClass: "col-auto heart-holder"
    }, [_c('div', {
      staticClass: "heart",
      class: {
        'is-active': false
      },
      attrs: {
        "title": "Add to Wishlist"
      },
      on: {
        "click": function($event) {
          _vm.goToLogin()
        }
      }
    })]) : _vm._e()])], 1)])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "options": _vm.swiperOptionLib
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev swiper-lib-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-lib-next",
    slot: "button-next"
  })])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "text-left",
    attrs: {
      "id": "addplay",
      "hide-footer": "",
      "hide-header": "",
      "title": "Add to Playlist"
    }
  }, [_c('div', {
    staticClass: "social d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.CreateNewPlaylist')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "newplay"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-music"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name your playlist",
      "aria-describedby": "newplay"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("OR")]), _vm._v(" "), _c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('playlist.labels.AddToExistingPlaylists')) + " ")]), _vm._v(" "), _c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "stacked": "",
      "name": "flavour2",
      "options": _vm.options
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "showmore d-flex"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Show more")])])], 1), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.AddToPlaylist')))])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54eb6e80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/trendingCourses.vue
// module id = cB1k
// module chunks = 1